export default __webpack_public_path__ + "static/media/aa-coporation-logo-for-modal.e2a94e12.png";